import React from 'react';
import { FeaturesListSection } from 'libs/growth-platform-brand-system-v2/src/templates/FeaturesListSection';
import { morphism } from 'morphism';
import { schemaImage } from '../../morphismSchema/components/schemaImage';
import { classNames } from 'libs/growth-platform-brand-system-v2/src/utils/style';
import { Image } from 'libs/growth-platform-brand-system-v2/src/components/Image';
import { templateRowProps } from 'libs/growth-platform-brand-system-v2/src/components/Columns/Row';

const prepareBoxImageClassNames = (
  template: templateRowProps,
  index: number,
) => {
  if (template === 'full') {
    return classNames('aspect-spotFull');
  }
  if (template === 'spotleft') {
    if (index === 0) {
      return classNames('aspect-spotMedium');
    }
    return classNames('aspect-spotSmall');
  }
  if (template === 'spotright') {
    if (index === 1) {
      return classNames('aspect-spotMedium');
    }

    return classNames('aspect-spotSmall');
  }
};

const spotBigSpot =
  '(max-width: 1279px) 738px, (min-width: 1280px) 810px, 810px';
const spotSmallSpot =
  '(max-width: 1279px) 738px, (min-width: 1280px) 391px, 738px';
const spotFullSpot = [
  '(max-width: 738px) 702px',
  '(max-width: 1279px) 738px',
  '(min-width: 1280px) 1202px',
  '1202px',
];

const getImagesSizes = (template: templateRowProps, index: number) => {
  if (template === 'full') {
    return spotFullSpot;
  }
  if (template === 'spotleft') {
    if (index === 0) {
      return spotSmallSpot;
    }
    return spotBigSpot;
  }
  if (template === 'spotright') {
    if (index === 1) {
      return spotSmallSpot;
    }

    return spotBigSpot;
  }
};

export const FeaturesListComponent = ({ block }: any) => {
  const rows = block.rows.map(({ content, template }: any) => {
    return {
      template,
      content: content.map((item: any) => {
        const { title, description, image, pixelDensity } = item;
        const imgProps =
          image && morphism(schemaImage, { ...image, pixelDensity });

        return {
          title,
          description,
          image: image && (
            <div
              className={classNames(
                prepareBoxImageClassNames(template, content.indexOf(item)),
                'w-full',
                'relative',
                'overflow-hidden rounded-b-[28px]',
              )}
            >
              <Image
                {...imgProps}
                className={classNames(
                  imgProps,
                  'object-cover',
                  'w-full h-full',
                )}
                sizes={getImagesSizes(template, content.indexOf(item))}
              />
            </div>
          ),
        };
      }),
    };
  });

  return <FeaturesListSection {...block} rows={rows} />;
};

export default FeaturesListComponent;
